import { filterError } from '@femtasy/helpers';
import * as Sentry from '@sentry/react';

const hostname = self.location.hostname; // eslint-disable-line no-restricted-globals
const isLocalhost = hostname === 'localhost' || hostname === '127.0.0.1';

export const isSentryInitiated = !(isLocalhost || self.Cypress); // eslint-disable-line no-restricted-globals

if (isSentryInitiated) {
  const environment =
    process.env.IS_PRODUCTION === 'true' ? 'production' : 'staging';

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN_URL,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.01,
    environment,
    release: process.env.COMMIT_REF,
    maxBreadcrumbs: 30,
    normalizeDepth: 10,
    // https://docs.sentry.io/platforms/javascript/configuration/filtering/#using-platformidentifier-namebefore-send-
    beforeSend: filterError,
  });

  const isPWA =
    self.matchMedia('(display-mode: fullscreen)').matches || // eslint-disable-line no-restricted-globals
    self.matchMedia('(display-mode: standalone)').matches; // eslint-disable-line no-restricted-globals

  Sentry.setTag('pwa_added_to_homescreen', isPWA);
}

export default Sentry;
